import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { useAuthorizations } from 'hooks';
import InsuranceDocumentContainer from 'features/insuranceDocument/edit/general/InsuranceDocumentContainer';
import InsuranceOfferContainer from 'features/insuranceDocument/edit/offer/InsuranceOfferContainer';
import DocumentsContainer from 'features/insuranceDocument/edit/documents/DocumentsContainer';
import InsuranceOfferHistoryContainer from 'features/insuranceDocument/edit/offer/InsuranceOfferHistoryContainer';
import InsurancePolicyContainer from 'features/insuranceDocument/edit/policy/InsurancePolicyContainer';
import WorkflowContainer from 'features/workflow/components/WorkflowContainer';
import CommentsContainer from 'features/notes/CommentsContainer';
import VerificationsContainer from 'features/verification/components/VerificationsContainer';
import StateTransitionsContainer from 'features/stateTransitions/StateTransitionsContainer';
import ServiceLogsContainer from 'features/serviceLogs/components/ServiceLogsContainer';
import RcaFlowChecksContainer from 'features/settings/components/flowChecks/rcaChecks/RcaFlowChecksContainer';
import CascoFlowChecksContainer from 'features/settings/components/flowChecks/cascoChecks/CascoFlowChecksContainer';
import NotFound from 'components/common/NotFound';
import InsuranceDataContext from 'features/insuranceDocument/stepper/insuranceDataContext';
import AuthorizationCodes from 'features/common/constants/authorizationCodes';

const SwitcherComponent = ({ document, contextRef }) => {
  const { documentTypeId, documentStateId } = useContext(InsuranceDataContext);
  const authorizations = useAuthorizations(
    [
      AuthorizationCodes.hasRightToViewComments,
      AuthorizationCodes.hasRightToViewChecks,
      AuthorizationCodes.hasRightToViewStateTransitionsHistory,
      AuthorizationCodes.hasRightToEditWorkflow
    ],
    documentTypeId,
    documentStateId
  );

  return (
    <Switch>
      <Route exact path='/insurance-documents/:id(new)'>
        <InsuranceDocumentContainer isNew={document.isNew} documentId={document.documentId} />
      </Route>
      <Route exact path='/insurance-documents/:id(\d+)/generalData'>
        <InsuranceDocumentContainer isNew={document.isNew} documentId={document.documentId} />
      </Route>
      <Route exact path='/insurance-documents/:id(\d+)/offers'>
        <InsuranceOfferContainer documentId={document.documentId} currentStateCode={document.currentStateCode} contextRef={contextRef} />
      </Route>
      <Route exact path='/insurance-documents/:id(\d+)/documents'>
        <DocumentsContainer documentId={document.documentId} />
      </Route>
      <Route exact path='/insurance-documents/:id(\d+)/offers-history'>
        <InsuranceOfferHistoryContainer documentId={document.documentId} />
      </Route>
      <Route exact path='/insurance-documents/:id(\d+)/policy'>
        <InsurancePolicyContainer documentId={document.documentId} contextRef={contextRef} />
      </Route>
      {authorizations?.hasRightToEditWorkflow && (
        <Route exact path='/insurance-documents/:id(\d+)/workflows'>
          <WorkflowContainer documentId={document.documentId} />
        </Route>
      )}
      {authorizations?.hasRightToViewComments && (
        <Route exact path='/insurance-documents/:id(\d+)/notes'>
          <CommentsContainer documentId={document.documentId} />
        </Route>
      )}
      {authorizations?.hasRightToViewChecks && (
        <Route exact path='/insurance-documents/:id(\d+)/verifications'>
          <VerificationsContainer documentId={document.documentId} />
        </Route>
      )}
      {authorizations?.hasRightToViewStateTransitionsHistory && (
        <Route exact path='/insurance-documents/:id(\d+)/state-transitions'>
          <StateTransitionsContainer documentId={document.documentId} />
        </Route>
      )}
      <Route exact path='/insurance-documents/:id(\d+)/insurance-service-logs'>
        <ServiceLogsContainer documentId={document.documentId} />
      </Route>
      <Route exact path='/settings/casco-checks'>
        <CascoFlowChecksContainer />
      </Route>
      <Route exact path='/settings/rca-checks'>
        <RcaFlowChecksContainer />
      </Route>
      <Route path='*'>
        <NotFound />
      </Route>
    </Switch>
  );
};

SwitcherComponent.propTypes = {
  document: PropTypes.object,
  contextRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })])
};

export default SwitcherComponent;
